import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import RcPagination from 'rc-pagination';
import 'rc-pagination/dist/rc-pagination.min.css';

import Rate from '../Rate/Rate';
import { getCommentList, addZan } from '../../actions/comment';
import styles from './DetailCommentList.module.less';
import { logging } from '../../actions/log';
import faceDefault from '../../static/comment_header_def.svg';

const selectCommentList = createSelector(
  state => state.comment,
  comment => comment.commentList,
);

const selectCommentAddZan = createSelector(
  state => state.comment,
  comment => comment.addZan,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ appDetailsData, source }) => {
  const dispatch = useDispatch();
  const commentList = useSelector(selectCommentList);
  const addZanRet = useSelector(selectCommentAddZan);
  const logInfoData = useSelector(selectLogInfo);

  const pageSize = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [bizIdentity, setBizIdentity] = useState('');

  // 根据后端返回数据显示当前页面
  useEffect(() => {
    if (commentList && commentList.startIndex) {
      const pageIndex = Math.ceil(commentList.startIndex / pageSize);
      setCurrentPage(pageIndex);
    }
  }, [commentList]);
  useEffect(() => {
    let bizIdentityStr = null;
    if (source === 'zt') {
      bizIdentityStr = appDetailsData.ztCommentId;
    } else {
      bizIdentityStr =
        appDetailsData.androidType === '1' ? appDetailsData.packageName : appDetailsData.softID;
    }

    setBizIdentity(bizIdentityStr);
  }, []);

  useEffect(() => {
    // 点赞成功，重新获取当前页面的列表
    if (addZanRet) {
      changeNum(currentPage);
    }
  }, [addZanRet]);

  useEffect(() => {
    if (!bizIdentity) {
      return;
    }

    if (commentList && commentList.dataList && commentList.bizIdentity === bizIdentity) {
      setTotal(commentList.totalCount);
    } else {
      changeNum(1);
    }
  }, [commentList, bizIdentity]);

  const changeNum = useCallback(
    pageIndex => {
      if (!bizIdentity) {
        return;
      }
      setCurrentPage(pageIndex);
      const param = {
        bizIdentity,
        count: pageSize,
        orderBy: 'DATE',
        startIndex: (pageIndex - 1) * pageSize + 1,
      };
      if (window.CallNativeMethod) {
        // 获取用户是否登录
        const login_ST = window.CallNativeMethod('get_st');
        if (login_ST !== '') {
          param.isNeedUser = true;
        }
      }
      dispatch(getCommentList(param));
    },
    [dispatch, commentList, currentPage, pageSize, bizIdentity],
  );

  const handleAddZan = useCallback(
    item => {
      // 获取用户是否登录
      const userId = window.CallNativeMethod('get_user_id');
      const login_ST = window.CallNativeMethod('get_st');
      if (login_ST !== '' && userId) {
        dispatch(
          addZan({
            id: userId,
            originalCommentId: item.comment.originalCommentId,
            username: userId,
          }),
        );
        // 点击 赞
        dispatch(
          logging({
            category: 'C',
            action: source === 'zt' ? 'Special_Comment_Zan' : 'Zan',
            label: '',
            param2: {
              source: source === 'zt' ? `Special||${appDetailsData.ztId || ''}` : 'AppDetail||Zan',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      } else {
        window.CallNativeMethod('login');
        // 点击 登录
        dispatch(
          logging({
            category: 'C',
            action: 'Login',
            label: '',
            param2: {
              source: source === 'zt' ? `Special||${appDetailsData.ztId || ''}` : 'AppDetail||Zan',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [dispatch],
  );

  return commentList && commentList.dataList && commentList.dataList.length > 0 && total > 0 ? (
    <div className={styles.detail_comments}>
      <div className={styles.detail_title}>
        网友评论<span className={styles.comments_total}>（{total}条）</span>
      </div>
      <div className={styles.comments_list}>
        {commentList.hotdatalist &&
          commentList.hotdatalist.length > 0 &&
          commentList.hotdatalist.map((item, i) => (
            <div className={styles.comments_item} key={i}>
              <div className={styles.comment_user_icon_box}>
                <img
                  className={styles.comment_user_icon}
                  src={item.comment.headUrl || faceDefault}
                  alt=""
                />
                {item.comment.official && <div className={styles.comment_user_v} />}
              </div>
              <div className={styles.comment_content_box}>
                <div className={styles.comment_content_line}>
                  <div className={styles.comment_content_user}>
                    <div className={styles.content_user_name}>{item.comment.userName}</div>
                    <div className={styles.content_user_time}>{item.comment.createDate}</div>
                    <div className={styles.content_user_computer}>{item.comment.model}</div>
                    <div className={styles.content_user_top}>置顶</div>
                  </div>
                  {/* <div className={styles.comment_content_start}>
                    {source !== 'zt' && <Rate score={item.comment.grade} />}
                  </div> */}
                </div>
                {/* <div className={styles.comment_content_user_computer}>{item.comment.model}</div> */}
                <div
                  className={styles.comment_content}
                  dangerouslySetInnerHTML={{
                    __html: item.comment.content.split('\n').join('<br/>'),
                  }}
                />
              </div>
              <div className={styles.comment_start}>
                {source !== 'zt' && <Rate score={item.comment.grade} />}
              </div>
              <div
                className={styles.comment_finger}
                onClick={() => {
                  handleAddZan(item);
                }}
              >
                {item.hasZan === 0 ? (
                  <div className="iconfont icon-zan finger" />
                ) : (
                  <div className="iconfont icon-zan finger_active" />
                )}
                <div className="finger_num">{item.zanCounter}</div>
              </div>
            </div>
          ))}
        {commentList.dataList.map((item, i) => (
          <div className={styles.comments_item} key={i}>
            <div className={styles.comments_item_box}>
              <div className={styles.comment_user_icon_box}>
                <img
                  className={styles.comment_user_icon}
                  src={item.comment.headUrl || faceDefault}
                  alt=""
                />
                {item.comment.official && <div className={styles.comment_user_v} />}
              </div>
              <div className={styles.comment_content_box}>
                <div className={styles.comment_content_line}>
                  <div className={styles.comment_content_user}>
                    <div className={styles.content_user_name}>{item.comment.userName}</div>
                    <div className={styles.content_user_time}>{item.comment.createDate}</div>
                    <div className={styles.content_user_computer}>{item.comment.model}</div>
                  </div>
                  {/* <div className={styles.comment_content_start}>
                  <Rate score={item.comment.grade} rateInfo={{ staronColor: 'grey' }} />
                </div> */}
                </div>

                <div
                  className={styles.comment_content}
                  dangerouslySetInnerHTML={{
                    __html: item.comment.content.split('\n').join('<br/>'),
                  }}
                />
              </div>
            </div>
            <div className={styles.comment_start}>
              {source !== 'zt' && <Rate score={item.comment.grade} />}
            </div>
            <div
              className={styles.comment_finger}
              onClick={() => {
                handleAddZan(item);
              }}
            >
              {item.hasZan === 0 ? (
                <div className="iconfont icon-zan finger" />
              ) : (
                <div className="iconfont icon-zan finger_active" />
              )}
              <div className="finger_num">{item.zanCounter}</div>
            </div>
          </div>
        ))}
        {total > pageSize && (
          <div className={styles.page_RcPagination_box}>
            <RcPagination
              size="small"
              current={currentPage}
              pageSize={pageSize}
              defaultPageSize={pageSize}
              total={total}
              onChange={changeNum}
              showSizeChanger
              className={styles.page_RcPagination}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className={styles.detail_comments_error}>
      <div className={styles.detail_title}>
        网友评论<span className={styles.comments_total}>（0条）</span>
      </div>
    </div>
  );
});
